import { z } from 'zod'

import { listFeedbackFormsQuerySearchMax } from '@gto/api-client/admin/zod'

import { trimmedTextParam } from '@/utils/search-params'

import { STATUS_CHOICES } from './feedback-form-labels'

/**
 * The forms list keeps its view in the URL, so staff can hand a colleague the
 * exact page and filter they see. `page` is 1-based, as the address bar shows
 * it. An unknown status is dropped rather than forwarded: the endpoint answers
 * it with a 422, and the unfiltered list is the better landing.
 */
export const feedbackFormsSearchSchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  status: z.enum(STATUS_CHOICES).optional().catch(undefined),
  search: trimmedTextParam(listFeedbackFormsQuerySearchMax),
})

export type FeedbackFormsSearch = z.infer<typeof feedbackFormsSearchSchema>
